import { createContext, useContext } from 'react';

interface Authorization {
  id: number;
  planId: number;
  maxAccount: number;
  maxAMSProfiles: number;
  maxVendor: number;
  maxSeller: number;
  maxInvites: number;
  maxMarketingStreamAccount: number;
}

interface AuthorizationContextType {
  authorization: Authorization | null;
}

const PlanAuthorizationContext = createContext<
  AuthorizationContextType | undefined
>(undefined);

export const PlanAuthorizationProvider = ({
  children,
  authorization,
}: {
  children: React.ReactNode;
  authorization: Authorization | null;
}) => {
  return (
    <PlanAuthorizationContext.Provider value={{ authorization }}>
      {children}
    </PlanAuthorizationContext.Provider>
  );
};

export const usePlanAuthorization = () => {
  const ctx = useContext(PlanAuthorizationContext);
  if (!ctx)
    throw new Error(
      'useAuthorization must be used within AuthorizationProvider'
    );
  return ctx;
};
